export default "__VITE_ASSET__DC$nQhBZ__"